module.exports = __webpack_public_path__ + "static/media/2 (32).1a6020e2.jpg";